"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SdPlatformModelApi = exports.SdPlatformModelGetEmbeddableFields = exports.SdPlatformModelQueryEmbeddableFields = void 0;
const SdPlatformRequestId_1 = require("../api/SdPlatformRequestId");
const ResourcesApi_1 = require("./commons/ResourcesApi");
var SdPlatformModelQueryEmbeddableFields;
(function (SdPlatformModelQueryEmbeddableFields) {
    SdPlatformModelQueryEmbeddableFields["Accessdomains"] = "accessdomains";
    SdPlatformModelQueryEmbeddableFields["GlobalAccessdomains"] = "global_accessdomains";
    SdPlatformModelQueryEmbeddableFields["BackendSystem"] = "backend_system";
    SdPlatformModelQueryEmbeddableFields["Tags"] = "tags";
    SdPlatformModelQueryEmbeddableFields["User"] = "user";
    SdPlatformModelQueryEmbeddableFields["Decoration"] = "decoration";
    SdPlatformModelQueryEmbeddableFields["Bookmark"] = "bookmark";
    SdPlatformModelQueryEmbeddableFields["Organization"] = "organization";
})(SdPlatformModelQueryEmbeddableFields = exports.SdPlatformModelQueryEmbeddableFields || (exports.SdPlatformModelQueryEmbeddableFields = {}));
var SdPlatformModelGetEmbeddableFields;
(function (SdPlatformModelGetEmbeddableFields) {
    SdPlatformModelGetEmbeddableFields["Accessdomains"] = "accessdomains";
    SdPlatformModelGetEmbeddableFields["GlobalAccessdomains"] = "global_accessdomains";
    SdPlatformModelGetEmbeddableFields["BackendSystem"] = "backend_system";
    SdPlatformModelGetEmbeddableFields["BackendProperties"] = "backend_properties";
    SdPlatformModelGetEmbeddableFields["Tags"] = "tags";
    SdPlatformModelGetEmbeddableFields["User"] = "user";
    SdPlatformModelGetEmbeddableFields["Decoration"] = "decoration";
    SdPlatformModelGetEmbeddableFields["Bookmark"] = "bookmark";
    SdPlatformModelGetEmbeddableFields["Ticket"] = "ticket";
    SdPlatformModelGetEmbeddableFields["AuthorTicket"] = "author_ticket";
    SdPlatformModelGetEmbeddableFields["BackendTicket"] = "backend_ticket";
    SdPlatformModelGetEmbeddableFields["Organization"] = "organization";
    SdPlatformModelGetEmbeddableFields["TokenView"] = "token_view";
    SdPlatformModelGetEmbeddableFields["TokenExport"] = "token_export";
    SdPlatformModelGetEmbeddableFields["TokenOwner"] = "token_owner";
    /**
     * Based on permissions get the token_view and/or token_export. If none of these permissions are available request is denied.
     */
    SdPlatformModelGetEmbeddableFields["TokenExportFallback"] = "token_export_fallback";
    /**
     * Based on permissions get the token_view, token_export and/or token_owner. If none of these permissions are available request is denied.
     */
    SdPlatformModelGetEmbeddableFields["TokenOwnerFallback"] = "token_owner_fallback";
})(SdPlatformModelGetEmbeddableFields = exports.SdPlatformModelGetEmbeddableFields || (exports.SdPlatformModelGetEmbeddableFields = {}));
/**
 * Operations for models on the ShapeDiver Platform.
 */
class SdPlatformModelApi extends ResourcesApi_1.ResourcesApi {
    get __resourcePath() {
        return "models";
    }
    /**
     * Get model by id, guid, slug, or link_sharing_slug.
     * @param  id - the model id.
     * @param embed array of {@link SdPlatformModelGetEmbeddableFields} embeddable properties.
     * @returns get response with a model.
     */
    get(id, embed = []) {
        return super.__get(SdPlatformRequestId_1.RequestId.ModelGet, id, embed);
    }
    /**
     * Queries the models.
     * @param  query {@link SdPlatformModelQueryParameters}
     * @returns the {@link SdPlatformQueryResponse} response with one of {@link SdPlatformResponseModelPublic} as result.
     */
    query(query = {}) {
        return super.__query(SdPlatformRequestId_1.RequestId.ModelQuery, query);
    }
    /**
     * Create a model.
     * @param body {@link SdPlatformRequestModelCreate} the parameters of a model.
     * @returns the {@link SdPlatformPostResponse} response with {@link SdPlatformResponseModelOwner} as result.
     */
    create(body = {}) {
        return super.__post(SdPlatformRequestId_1.RequestId.ModelCreate, body);
    }
    /**
     * Patch a model, e.g. to update its status to "done" after successful upload and model checking
     * @param id - the model id.
     * @param params {@link SdPlatformRequestModelPatch} or {@link SdPlatformRequestModelPatchAdmin} as patch paramaters
     * @returns { Promise<SdPlatformPatchResponse<T>> }
     */
    patch(id, params) {
        return super.__patch(SdPlatformRequestId_1.RequestId.ModelPatch, id, params);
    }
    /**
     * Deletes a model.
     * @param id - the model id.
     * @returns the {@link SdPlatformDeleteResponse} response.
     */
    delete(id) {
        return super.__delete(SdPlatformRequestId_1.RequestId.ModelDelete, id);
    }
    /**
     *  Decrypt a ticket, the calling user must have permission "decrypt_ticket" for the model identified by the ticket.
     * @param ticket
     * @returns decrypted ticket result {@link SdPlatformResponseDecryptTicketResult}
     */
    decryptTicket(ticket) {
        return super.__action(SdPlatformRequestId_1.RequestId.DecryptTicket, ResourcesApi_1.Action.Post, "decrypt_ticket", {
            ticket
        });
    }
    /**
     * Post method which is to be used to fetch data necessary for iframe embedding of a model using the ShapeDiver Viewer.
     * @param slug - the model slug.
     * @param parameters - optional parameters
     * @returns the {@link SdPlatformPostResponse} with {@link SdPlatformResponseIFrameData} as data.
     */
    iframeEmbedding(slug, parameters = {}) {
        const is_iframe = parent !== window;
        const origin = is_iframe
            ? document.referrer.split('/').slice(0, 3).join('/')
            : window.location.origin;
        return super.__action(SdPlatformRequestId_1.RequestId.ModelIframeData, ResourcesApi_1.Action.Post, `iframe/${slug}`, parameters, {
            "X-ShapeDiver-Origin": origin
        });
    }
}
exports.SdPlatformModelApi = SdPlatformModelApi;
//# sourceMappingURL=SdPlatformModelApi.js.map